function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, getCurrentInstance } from "vue";
import CommonUploader from "@/components/Uploader/index.vue";
import { v2Host } from "@/config/host";
import { getApiPath } from "@/common/api-proxy.js";
import { updateAssets } from "@pt/api/assets";
import { Message } from "element-ui";
import { t } from "@/lang";
export default defineComponent({
    components: {
        CommonUploader: CommonUploader
    },
    props: {
        category: {
            type: Object,
            required: true
        },
        resource: {
            type: Object,
            default: function() {
                return null;
            }
        },
        buttonAttrs: {
            type: Object
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var isUploading = ref(false);
        var handleBeforeUpload = function(file) {
            isUploading.value = true;
            if (file.size > 0.5 * 1024 * 1024) {
                isUploading.value = false;
                Message({
                    type: "error",
                    message: String(t("basic.upload.fontWaring", {
                        type: "jpg/png",
                        size: "500kb"
                    }))
                });
                return false;
            }
            return true;
        };
        var handleSuccess = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(response) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(response.code === 1)) {
                                _ctx.next = 4;
                                break;
                            }
                            Message.error(response.msg);
                            isUploading.value = false;
                            return _ctx.abrupt("return");
                        case 4:
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return updateAssets({
                                id: props.resource.res_id,
                                cover_url: response.data.file_path
                            });
                        case 7:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                Message({
                                    type: "success",
                                    message: String(t("basic.upload.fileStatus.success"))
                                });
                            }
                            isUploading.value = false;
                            store.dispatch("creative/template/updateResource", _objectSpreadProps(_objectSpread({}, props.resource), {
                                extra: _objectSpreadProps(_objectSpread({}, props.resource.extra), {
                                    thumb_url: res.data.data.cover_url
                                })
                            }));
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](4);
                            console.log(_ctx.t0);
                        case 16:
                            emit("select", response.data.url);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        13
                    ]
                ]);
            }));
            return function handleSuccess(response) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleError = function() {
            isUploading.value = false;
        };
        var uploaderAttrs = {
            action: "".concat(v2Host).concat(getApiPath("/upload/file")),
            multiple: false,
            showFileList: false,
            accept: ".jpg,.png",
            data: {
                bucket: "mws-files",
                mod: "assets"
            },
            beforeUpload: handleBeforeUpload,
            onSuccess: handleSuccess,
            onError: handleError
        };
        return {
            uploaderAttrs: uploaderAttrs,
            isUploading: isUploading
        };
    }
});
